import _extends from "@babel/runtime/helpers/extends";
import isObject from '@tinkoff/utils/is/object';
import isString from '@tinkoff/utils/is/string';
import cn from 'classnames';
export const getElementStyles = (key, styleSlot, componentStyleSlot, props) => {
  const result = _extends({}, componentStyleSlot, {
    'data-style-layer': key
  });
  if (isString(styleSlot)) {
    result.className = cn(result.className, styleSlot);
  } else if (isObject(styleSlot)) {
    result.className = cn(result.className, styleSlot.className);
    result.style = _extends({}, result.style, styleSlot.style, styleSlot.vars == null ? void 0 : styleSlot.vars(props));
  }
  return result;
};